import { Component, OnInit } from '@angular/core';
import {Menu} from '../../models/menu';
import {Router} from '@angular/router';
import {BaseService} from '../../base.service';
import {MenuService} from '../../services/menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: []
})
export class MenuComponent implements OnInit {

  private title_component: string;
  private title_panel: string;
  private menus: Menu[];

  constructor(
    private router: Router,
    private baseService: BaseService,
    private menuService: MenuService
  ) {}

  ngOnInit() {
    this.title_component = 'Menus';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Lista de Menu';
    this.getAll();
  }

  getAll(): void {
    this.menuService.getAll().subscribe(data => {
      if (data) {
        this.menus = data;
      }
    });
  }

  getDetail(event, id: number): void {
    const link = ['/dashboard/menu', id];
    this.router.navigate(link);
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/menu/menu.component.ts